<template>
  <v-navigation-drawer v-model="showDialog" absolute temporary right width="800">
    <div class="pa-3" v-if="poi!=null">
      <div style="height:100px;"></div>
      <h3>{{poi.poi_name}}</h3>
      <div>{{poi.poi_excerpt}}</div>
      <!--
      <div
        class="my-3"
        v-for="(hour, index ) in poi.poi_detail_json.opening_hours.periods"
        v-bind:key="index"
      >{{hour.open.time}} - {{hour.close.time}}</div>
      <div class="my-3">{{poi.poi_detail_json.reviews[0].text}}</div>
      -->
    </div>
  </v-navigation-drawer>
</template>
<script>
import Service from "../../services";
import { monthList } from "../../utils/Constants";

export default {
  name: "poi-detail",
  props: {
    dialog: { default: false },
    poi: { default: null }
  },
  data() {
    return {};
  },
  computed: {
    showDialog: {
      get() {
        console.log(this.poi);
        return this.dialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      }
    }
  },
  created() {}
};
</script>